// Header.jsx - Alternative (Simpler but user stays logged in to Microsoft)
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { msalInstance } from '../utils/msalInstance';
import apiClient from '../utils/axiosConfig';
import logo from '../assets/logo.svg';
import { toast } from 'react-toastify';

const Header = ({ headerTitle }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    try {
      // Call backend to clear httpOnly cookie/session
      await apiClient.post('/auth/logout');

      // Clear client-side storage
      try { localStorage.removeItem('token'); } catch (e) {}
      try { localStorage.removeItem('user'); } catch (e) {}
      try { sessionStorage.clear(); } catch (e) {}

      // Notify other parts of the app
      window.dispatchEvent(new CustomEvent('loggedOut'));

      // Attempt MSAL logout (best-effort)
      try {
        if (msalInstance && msalInstance.logoutRedirect) {
          msalInstance.logoutRedirect().catch(() => {});
        }
      } catch (e) { /* ignore */ }

      toast.success('Logged out successfully');
      navigate('/', { replace: true });
    } catch (error) {
      console.error('Logout error:', error);
      // If server responded with 401 (no token/cookie), still clear client state
      if (error.response?.status === 401) {
        try { localStorage.removeItem('token'); } catch (e) {}
        try { localStorage.removeItem('user'); } catch (e) {}
        try { sessionStorage.clear(); } catch (e) {}
        window.dispatchEvent(new CustomEvent('loggedOut'));
        toast.success('Logged out');
        navigate('/', { replace: true });
        return;
      }

      toast.error('Logout failed. Please try again.');
    }
  };

  return (
        <header className="bg-white text-black p-4 shadow-md" style={{ padding: "20px"}}>
                <div className="flex justify-between items-center">
                    <div className="flex items-center">
                        <img src={logo} alt="Logo" className="h-8 w-auto" />
                    </div>
                    <div className="absolute left-1/2 transform -translate-x-1/2">
                        <h1 className="text-xl font-bold">{headerTitle}</h1>
                    </div>
                    <div className="flex items-center gap-2">
                        {location.pathname !== '/dashboard' && (
                            <button 
                            onClick={() => navigate(-1)} 
                            className="bg-gray-500 text-white p-2 rounded transition"
                        >
                            Back
                        </button>
                    )}
                        <button 
                            onClick={handleLogout} 
                            className="bg-red-500 text-white p-2 rounded"
                        >
                            Logout
                        </button>
                    </div>
                </div>
            </header>
    );
};

export default Header;